export default "__VITE_ASSET__f1670f1e__"